/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ExternalServiceType } from './ExternalServiceType.js';
import {
    ExternalServiceTypeFromJSON,
    ExternalServiceTypeFromJSONTyped,
    ExternalServiceTypeToJSON,
} from './ExternalServiceType.js';

/**
 * 
 * @export
 * @interface CreateExternalServiceRequest
 */
export interface CreateExternalServiceRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateExternalServiceRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateExternalServiceRequest
     */
    description?: string;
    /**
     * 
     * @type {any}
     * @memberof CreateExternalServiceRequest
     */
    options?: any;
    /**
     * 
     * @type {ExternalServiceType}
     * @memberof CreateExternalServiceRequest
     */
    type?: ExternalServiceType;
}

/**
 * Check if a given object implements the CreateExternalServiceRequest interface.
 */
export function instanceOfCreateExternalServiceRequest(value: object): boolean {
    return true;
}

export function CreateExternalServiceRequestFromJSON(json: any): CreateExternalServiceRequest {
    return CreateExternalServiceRequestFromJSONTyped(json, false);
}

export function CreateExternalServiceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateExternalServiceRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'options': json['options'] == null ? undefined : json['options'],
        'type': json['type'] == null ? undefined : ExternalServiceTypeFromJSON(json['type']),
    };
}

export function CreateExternalServiceRequestToJSON(value?: CreateExternalServiceRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'description': value['description'],
        'options': value['options'],
        'type': ExternalServiceTypeToJSON(value['type']),
    };
}

